/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Trust_ProductsInputs */

const he_home_trust_products = /** @type {(inputs: Home_Trust_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300K+ מוצרים`)
};

const en_home_trust_products = /** @type {(inputs: Home_Trust_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300K+ products`)
};

/**
* | output |
* | --- |
* | "300K+ products" |
*
* @param {Home_Trust_ProductsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_trust_products = /** @type {((inputs?: Home_Trust_ProductsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trust_ProductsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_trust_products(inputs)
	return en_home_trust_products(inputs)
});